import { action, computed, makeObservable, observable } from 'mobx';
import { DWTUrlParamName, DWTUrlParams } from './url-params';
import { urlService } from './url.service';

export class UrlStore {
  public href: string = window.location.href;

  public search = window.location.search;

  public get searchParams() {
    return urlService.extractParams(this.search);
  }

  constructor() {
    makeObservable(this, {
      href: observable,
      search: observable,
      searchParams: computed,
      snapshotAndSet: action,
      setParams: action,
      setParam: action,
      removeParam: action,
    });

    this.addEventListeners();
  }

  public snapshotAndSet() {
    this.href = window.location.href;
    this.search = window.location.search;
  }

  public setParams(newParams: Partial<DWTUrlParams>) {
    const filteredParams = (Object.keys(newParams) as DWTUrlParamName[])
      .filter((name) => this.searchParams[name] !== newParams[name])
      .reduce<Partial<DWTUrlParams>>((partialFilteredParams, name) => {
        partialFilteredParams[name] = newParams[name] as any;
        return partialFilteredParams;
      }, {});
    if (Object.keys(filteredParams).length) {
      urlService.setParams(filteredParams);
      this.snapshotAndSet();
    }
  }

  public getNextUrl(newParams: Partial<DWTUrlParams>) {
    return urlService.getNextUrl(this.href, newParams);
  }

  public getNextUrlWithHref(href: string, newParams: Partial<DWTUrlParams>) {
    return urlService.getNextUrl(href, newParams, true);
  }

  public setParam(name: DWTUrlParamName, value: string | number | boolean | undefined) {
    this.setParams({ [name]: value });
  }

  public removeParam(name: DWTUrlParamName) {
    urlService.removeParam(name);
    this.snapshotAndSet();
  }

  private addEventListeners() {
    window.addEventListener('changestate', () => this.snapshotAndSet());
    window.addEventListener('popstate', () => this.snapshotAndSet());
    window.addEventListener('hashchange', () => this.snapshotAndSet());
  }
}
